import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=1f6ddf4e&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=1f6ddf4e&prod&scoped=true&lang=css"
import style1 from "./Organization.vue?vue&type=style&index=1&id=1f6ddf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ddf4e",
  null
  
)

export default component.exports